import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { AUTH_FORM_DROP_DOWN_STYLE, ERRORS, ROUTES, SIGN_UP_ERRORS } from "../../../constants";
import { NOTIFICATION_KEYWORDS, REGEX } from "../../../constants";
import { AuthService } from "../../../services/auth.service";
import { I18nService } from "../../../services/i18n.service";
import { NotificationService } from "../../../services/notification.service";
import { UtilityService } from "../../../services/utility.service";

@Component( {
	selector: "app-forgot-password",
	templateUrl: "./forgot-password.component.html",
	styleUrls: [ "./forgot-password.component.scss" ]
} )

export class ForgotPasswordComponent implements OnInit {

	forgotPasswordForm: FormGroup;
	userType: string = "buyer";
	dropDownStyle = AUTH_FORM_DROP_DOWN_STYLE;

	listOfOption = [
		{
			label: "global.user_type.buyer",
			value: "buyer"
		},
		{
			label: "global.user_type.supplier",
			value: "supplier"
		}
	];

	constructor(
		private i18nService: I18nService,
		private formBuilder: FormBuilder,
		private notificationService: NotificationService,
		private authService: AuthService,
		private spinnerService: NgxSpinnerService,
		public utilityService: UtilityService
	) { }

	ngOnInit(): void {
		this.forgotPasswordForm = this.formBuilder.group( {
			email: [ null, [ Validators.required ] ]
		} );

		this.forgotPasswordForm.valueChanges.subscribe( ( value ) => {
			const emailRegex = REGEX.EMAIL;

			if ( value.email && value.email.endsWith( "@" ) ) {
				this.forgotPasswordForm.controls["email"].setErrors( { "incompleteEmail": true } );
			} else if ( value.email && !value.email.match( emailRegex ) ) {
				this.forgotPasswordForm.controls["email"].setErrors( { "invalidEmail": true } );
			}
		} );
	}

	/**
	 * Function for the submission of a forgot password form.
	 */
	submitForgotPasswordForm(userType): void {
		for ( const control in this.forgotPasswordForm.controls ) {
			this.forgotPasswordForm.controls[control].markAsDirty();
			this.forgotPasswordForm.controls[control].updateValueAndValidity();
		}

		const forgotPasswordData = {
			email: this.forgotPasswordForm.controls["email"].value
		};

		this.spinnerService.show();
		this.authService.forgotPassword( forgotPasswordData, userType ).subscribe( ( response ) => {
			if ( response ) {
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.FORGOT_PASSWORD );
				this.spinnerService.hide();
				this.utilityService.navigate( ROUTES.LOG_IN );
			}
		}, ( error ) => {
			if (error.status === 403 && error.error.message === SIGN_UP_ERRORS.USER_NOT_ACTIVATED) {
				this.notificationService.failureNotification(NOTIFICATION_KEYWORDS.ACCOUNT_NOT_ACTIVATED);
			} else {
				this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.FORGOT_PASSWORD );
			}
			this.spinnerService.hide();
			this.utilityService.navigate( ROUTES.LOG_IN );
			if(this.forgotPasswordForm.controls["email"].value) {
				error.email = this.forgotPasswordForm.controls["email"].value;
			}
		} );


	}

	/**
	 *	Change language function
	 * @param language : language string
	 */
	changeLanguage( language: string ): void {
		this.i18nService.switchLanguage( language );
	}

	/**
	 * Navigate to Login page
	 */
	redirectToLoginPage(): void {
		this.utilityService.navigate( ROUTES.LOG_IN );
	}
}
